//GeneratorFlag:[NoChange]
import PersonNationality from './person-nationality';

export default {PersonNationality}
export{PersonNationality}